import { CircularProgress, IconButton, InputAdornment } from "@mui/material";
import { useEffect, useState } from "react";
import "../Login/Login.css";
import emailIcon from "../../assets/login_mail.svg";
import HomeNavbar from "../../Components/HomeNavbar/HomeNavbar";
import { useSnackbar } from "../../context/SnackbarContext";
import passwordIcon from "../../assets/login_password.svg";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { signupApi } from "../../api/auth";
import { useForm } from "react-hook-form";
import {
  checkValidEmail,
  SignupSchema,
  SignupSchemaType,
} from "./SignupSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import TextField from "../../Components/TextField";
import PhoneNumberInput from "../../Components/PhoneNumberInput/PhoneNumberInput";
import { useRegion } from "../../context/RegionContext";
import { REGIONS } from "../../constants/regions";
import { images } from "../../assets/images";

const Signup = () => {
  // const { showSnackbar } = useSnackbar();
  const { region, countryId } = useRegion();
  
  const { register, handleSubmit, formState, watch } =
    useForm<SignupSchemaType>({
      mode: "onTouched",
      resolver: yupResolver(SignupSchema),
      defaultValues: { name: "", email: "", companyName: "", password: "" },
    });

  const [emailError, setEmailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const emailVal = watch("email");
  const nameVal = watch("name");
  const companyVal = watch("companyName");
  const passVal = watch("password");

  useEffect(() => {
    setEmailError("");
  }, [emailVal]);

  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    companyName: "",
    password: "",
  });

  const [countryCode, setCountryCode] = useState("+971");

  const setPhoneNumber = (number: string) => {
    setForm((prevState) => ({
      ...prevState,
      ["phoneNumber"]: number,
    }));
  };

  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const { showSnackbar } = useSnackbar();

  const handleSendOtp = async (e: SignupSchemaType) => {
    setLoading(true);

    if (
      !!e.email.length &&
      !!e.name.length &&
      e.companyName.length &&
      e.password.length > 7 &&
      !!form.phoneNumber.length &&
      !!countryCode.length
    ) {
      const countryName = region === REGIONS.SA ? "ksa" : "uae";

      const resp = await signupApi(
        e.email,
        e.name,
        e.companyName,
        countryCode,
        form.phoneNumber,
        e.password,
        countryName,
        countryId ?? undefined
      );

      if (resp?.responseInfo?.httpCode === 200) {
        setDone(true);
        showSnackbar(resp?.responseInfo?.description, "success");
      } else if (resp?.responseInfo?.httpCode === 409) {
        setEmailError(resp?.responseInfo?.description);
      } else {
        showSnackbar(resp?.responseInfo?.description, "error");
      }
    } else {
      showSnackbar(
        "Please fill out needed fields first so that you can create an account",
        "error"
      );
    }

    setLoading(false);
  };

  const handleDone = (e: SignupSchemaType) => {
    handleSendOtp(e);
  };

  return (
    <div className="login_navbar_container">
      <HomeNavbar isHome={true} />

      <div className="main_login_container_ak">
        <div className="login_content_wrapper">
          <div className="login_body_wrapper">
            <div className="login_content_holder">
              <h1 className="white_text">
                Claim Your Free Pass! Access premium features now.{" "}
              </h1>
              <div className="white_text">
                Effortlessly post job openings, filter applicants with advanced
                AI tools, and connect directly with Emirati talent. Simplify
                your hiring process today!
              </div>
              <img
                src={images.macbookProLight}
                alt="dashboard"
                className="laptop_img"
              />
            </div>
          </div>
          <div className="login_form_wrapper_ak">
            <div className="login">
              {done ? (
                <div className="forgot-form-container">
                  <img
                    src={images.otpemail}
                    alt="otp_email"
                    className="form_img_item"
                  />
                  <h2 className="text-center">Verify your email</h2>
                  <p className="text-center gray-text">
                    Check your email we have sent a verification email.
                  </p>
                  <form
                    className="login-form"
                    onSubmit={handleSubmit(handleDone)}
                  >
                    <div className="input-container">
                      <div className="submit-container">
                        <button className="submit-button" type="submit">
                          Resend
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              ) : (
                <div className="login-form-container create_account_wrapper">
                  <h2 className="text-center">Create an account</h2>
                  <p className="gray_text text-center">
                    Claim Your Free Pass! Access premium features now.
                  </p>
                  <form
                    className="login-form textFieldWrapper"
                    onSubmit={handleSubmit(handleSendOtp)}
                  >
                    <div className="textFieldSpacing">
                      <TextField
                        label=""
                        fullWidth
                        placeholder="Full Name"
                        autoComplete="new-password"
                        {...register("name")}
                        error={!!formState.errors.name}
                        helperText={formState.errors.name?.message}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <img
                                src={images.user}
                                alt="user_icon"
                              />
                            </InputAdornment>
                          ),
                        }}
                      />
                      <PhoneNumberInput
                        setMainCountryCode={setCountryCode}
                        setMainPhoneNumber={setPhoneNumber}
                        setErrorMessage={setPhoneError}
                        errorMessage={phoneError}
                      />

                      <TextField
                        label=""
                        fullWidth
                        placeholder="Company Name"
                        autoComplete="new-password"
                        {...register("companyName")}
                        error={!!formState.errors.companyName}
                        helperText={formState.errors.companyName?.message}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <img
                                src={images.briefcase}
                                alt="company_icon"
                              />
                            </InputAdornment>
                          ),
                        }}
                      />

                      <TextField
                        label=""
                        fullWidth
                        placeholder="Email"
                        autoComplete="new-password"
                        {...register("email")}
                        error={!!formState.errors.email || !!emailError}
                        helperText={
                          formState.errors.email?.message || emailError
                        }
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <img src={emailIcon} alt="user_icon" />
                            </InputAdornment>
                          ),
                        }}
                      />

                      <TextField
                        label=""
                        fullWidth
                        placeholder="Password"
                        type={showPassword ? "text" : "password"}
                        autoComplete="new-password"
                        {...register("password")}
                        error={!!formState.errors.password}
                        helperText={formState.errors.password?.message}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <img
                                onClick={handleTogglePasswordVisibility}
                                src={passwordIcon}
                                alt="password_icon"
                              />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={handleTogglePasswordVisibility}
                              edge="end"
                              style={{ marginRight: "4px" }}
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          ),
                        }}
                      />
                    </div>

                    {loading ? (
                      <div className="submit-container">
                        <button className="submit-button">
                          <CircularProgress size={20} color="inherit" />
                        </button>
                      </div>
                    ) : (
                      <div className="submit-container">
                        <button
                          disabled={
                            !!phoneError ||
                            !checkValidEmail(emailVal) ||
                            !nameVal.length ||
                            passVal.length < 8 ||
                            !companyVal.length
                          }
                          type="submit"
                          className="submit-button"
                        >
                          Create an account
                        </button>
                      </div>
                    )}
                  </form>
                  <div>
                    <p className="gray_text text-center">
                      Already have an account?
                    </p>
                    <Link to={`/login`} style={{ textDecoration: "none" }}>
                      {" "}
                      <h1 className="forgot-label text-center">Log In</h1>
                    </Link>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
